import { useState } from "react";

const GoldChitAd = () => {
  const [managers] = useState([
    {
      id: 1,
      nick: "திருமதி",
      name: "Manimegalai K",
      phone: "+918903059440",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      specialty: "மேலாளர்",
      specialtyEn: "Manager",
      experience: "8+ years",
      role: "manager",
    },
    {
      id: 2,
      nick: "திருமதி",
      name: "Gomathi N",
      phone: "+918903059440",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      specialty: "துணை மேலாளர்",
      specialtyEn: "Assistant Manager",
      experience: "6+ years",
      role: "manager",
    },
    {
      id: 3,
      name: "Jamuna",
      nick: "திருமதி",
      phone: "+919487335595",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      specialty: "துணை மேலாளர்",
      specialtyEn: "Assistant Manager",
      experience: "10+ years",
      role: "manager",
    },
    {
      id: 4,
      name: "Ranjitha",
      nick: "திருமதி",
      phone: "+918675787552",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      specialty: "துணை மேலாளர்",
      specialtyEn: "Assistant Manager",
      experience: "7+ years",
      role: "manager",
    },
    {
      id: 5,
      nick: "திருமதி",
      name: "Kavitha",
      phone: "+919487335595",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      specialty: "துணை மேலாளர்",
      specialtyEn: "Assistant Manager",
      experience: "9+ years",
      role: "manager",
    },
    {
      id: 6,
      nick: "திருமதி",
      name: "Valli K",
      phone: "+918838255595",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      specialty: "Chief Executive Officer",
      specialtyEn: "Chief Executive Officer",
      experience: "15+ years",
      role: "ceo",
      achievements:
        "Built India's fastest growing gold investment platform",
    },
    {
      id: 7,
      nick: "திருமதி",
      name: "Pradeepa",
      phone: "+918903050494",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      specialty: "கணக்கு அலுவலர்",
      specialtyEn: "Accountant",
      experience: "8+ years",
      role: "accountant",
    },
    {
      id: 8,
      nick: "செல்வி",
      name: "Devi",
      phone: "+918903050494",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      specialty: "கணக்கு அலுவலர்",
      specialtyEn: "Accountant",
      experience: "6+ years",
      role: "accountant",
    },
    {
      id: 9,
      nick: "திருமதி",
      name: "Gomathi R",
      phone: "+918675787552",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      specialty: "கணக்கு அலுவலர்",
      specialtyEn: "Accountant",
      experience: "10+ years",
      role: "accountant",
    },
    {
      id: 10,
      nick: "செல்வி",
      name: "Nandhini",
      phone: "+919080857464",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      specialty: "கணக்கு அலுவலர்",
      specialtyEn: "Accountant",
      experience: "7+ years",
      role: "accountant",
    },
    {
      id: 11,
      nick: "திருமதி",
      name: "Nathiya",
      phone: "+919080857464",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      specialty: "கணக்கு அலுவலர்",
      specialtyEn: "Accountant",
      experience: "9+ years",
      role: "accountant",
    },
    {
      id: 12,
      nick: "திரு",
      name: "Eswaran",
      phone: "+919677622877",
      image:
        "https://images.unsplash.com/photo-1595152772835-219674b2a8a6?w=150&h=150&fit=crop&crop=face",
      specialty: "வசூல் அலுவலர்",
      specialtyEn: "Collection Officer",
      experience: "9+ years",
      role: "accountant",
    },
    {
      id: 12,
      nick: "திருமதி",
      name: "Bharathi",
      phone: "+919080857464",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      specialty: "துணை மேலாளர்",
      specialtyEn: "Assistant Manager",
      experience: "9+ years",
      role: "manager",
    },
  ]);

  const handleWhatsAppClick = (person) => {
    const phone = person.phone.replace(/\D/g, ""); // Clean phone number
    const message = `GVG நிறுவனத்தின் ${person.specialty} ${person.nick} ${person.name}, அவர்களே, 🙏 வணக்கம்.
தங்களது நிறுவனத்தின் சேவைகள் குறித்து மேலும் அறிந்து கொள்ளவும், அவற்றை பயன்படுத்தவும் நான் ஆவலாக உள்ளேன். 🦚
எனவே, அதன் முழுமையான விவரங்களை இந்த எனது WhatsApp எண்ணிற்கு அனுப்பி வைக்குமாறு பணிவுடன் கேட்டுக்கொள்கிறேன். 🙏`;
    const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-amber-50 py-8 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-7xl mx-auto">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <div className="bg-gradient-to-r from-amber-500 to-orange-600 rounded-3xl p-8 sm:p-12 shadow-2xl mb-8 relative overflow-hidden">
            <h1 className="text-5xl font-bold text-white mb-6">
              Start Your Golden Journey Today
            </h1>
            <p className="text-xl text-amber-100 max-w-3xl mx-auto leading-relaxed">
              Ready to secure your future with our trusted Gold Chit plans? Our
              experts will guide you to the perfect investment strategy.
            </p>
          </div>
        </div>

        {/* CEO Section */}
        <section className="mb-16">
          {managers
            .filter((m) => m.role === "ceo")
            .map((ceo) => (
              <div
                key={ceo.id}
                className="bg-white rounded-3xl p-8 shadow-2xl max-w-4xl mx-auto text-center"
              >
                <img
                  src={ceo.image}
                  alt={ceo.name}
                  className="w-40 h-40 rounded-full mx-auto mb-4 object-cover"
                />
                <h3 className="text-2xl font-bold">{ceo.name}</h3>
                <p className="text-orange-600 font-semibold mb-2">
                  {ceo.specialty}
                </p>
                <p className="text-gray-700 mb-4">{ceo.achievements}</p>
                <p className="font-semibold text-amber-700">
                  {ceo.experience} Experience
                </p>
              </div>
            ))}
        </section>

        {/* Manager Section */}
        <section className="mb-16">
          <h2 className="text-center text-4xl font-bold mb-8 bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent">
            Contact Our Managers
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
            {managers
              .filter((m) => m.role === "manager")
              .map((manager) => (
                <div
                  key={manager.id}
                  className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition"
                >
                  <img
                    src={manager.image}
                    alt={manager.name}
                    className="w-24 h-24 rounded-full mx-auto mb-4 object-cover"
                  />
                  <h3 className="text-xl font-bold text-gray-800 text-center">
                    {manager.name}
                  </h3>
                  <p className="text-center text-sm text-amber-600">
                    {manager.specialtyEn}
                  </p>
                  <p className="text-center text-gray-500 text-xs mb-3">
                    Experience: {manager.experience}
                  </p>
                  <button
                    onClick={() => handleWhatsAppClick(manager)}
                    className="w-full bg-green-600 text-white py-2 rounded-xl font-semibold hover:bg-green-700 transition"
                  >
                    Contact Now
                  </button>
                </div>
              ))}
          </div>
        </section>

        {/* Accountant Section */}
        <section>
          <h2 className="text-center text-4xl font-bold mb-8 bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent">
            Contact Our Account Staffs
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
            {managers
              .filter((m) => m.role === "accountant")
              .map((acc) => (
                <div
                  key={acc.id}
                  className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition"
                >
                  <img
                    src={acc.image}
                    alt={acc.name}
                    className="w-24 h-24 rounded-full mx-auto mb-4 object-cover"
                  />
                  <h3 className="text-xl font-bold text-gray-800 text-center">
                    {acc.name}
                  </h3>
                  <p className="text-center text-sm text-amber-600">
                    {acc.specialtyEn}
                  </p>
                  <p className="text-center text-gray-500 text-xs mb-3">
                    Experience: {acc.experience}
                  </p>
                  <button
                    onClick={() => handleWhatsAppClick(acc)}
                    className="w-full bg-green-600 text-white py-2 rounded-xl font-semibold hover:bg-green-700 transition"
                  >
                    Contact Now
                  </button>
                </div>
              ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default GoldChitAd;
